    
 const env = {
    clientUri: process.env.REACT_APP_CLIENT_URI,
   serverUri: process.env.REACT_APP_SERVER_URI,
   port: process.env.REACT_APP_PORT,
   socketUri: process.env.REACT_APP_SOCKET_URI,
   cryptoPaymentUri: process.env.REACT_APP_CRYPTO_PAYMENT_URI,
 };
 
  const config ={
     development :{ ...env },
     staging : { ...env },
     production :{ ...env }
 }
 
 export default config
 
 
   export const development = { ...env }
   export const staging = { ...env }
   export const production ={ ...env }
 
 
 
 
 